import React from 'react'
import { nest } from 'recompose'
import * as R from 'ramda'
import merge from 'lodash/merge'
import get from 'lodash/get'
import { fieldApps, fieldTypes, BODY } from '@infotech/view-config'
import { mapissuesModule } from '@infotech/4sides-front-core'
import { fieldsConf as mapissuesFieldsConf, IssueLinkFormatter, SYSTEM_ENTITY_NAMES } from '@infotech/mapissues'
import { FILTER_TYPE_LIKE, textSearchFilters, ftsFilters } from '@infotech/filters'
import { WithTitle, Text, InputHelper, Input, formFieldAdapter, withDebounce } from '@infotech/base-components'
import { UserSelect } from '@infotech/4sides-components'
import UIKitInput from '@infotech/uikit-input'
import {
  MyUserAgreementsCrudFilter,
  myUserAgreementsFilterValueToFilter,
  myUserAgreementsFilterParseValue,
} from '@infotech/agreement'

import StatusEdit from './components/StatusEdit'
import Equipment from './components/Form/Equipment'

const { defaultModuleConfig } = mapissuesModule.config

const DebouncedUIKitInput = formFieldAdapter(nest(InputHelper, withDebounce(UIKitInput)))

const energyFieldsConfig = {
  id: {
    apps: {
      [fieldApps.FILTER]: {
        title: `Поиск`,
        parseValue   : ftsFilters.parseValue,
        valueToFilter: ftsFilters.valueToFilter,
        fixed        : true,
      },
    },
  },
  createDate: {
    name: `Дата регистрации`,
    apps: {
      [fieldApps.COLUMN]: {
        name : `Дата регистрации`,
        width: 130,
      },
      [fieldApps.VIEW]: {
        title: `Дата регистрации`,
      },
      [fieldApps.FILTER]: {
        title         : `Дата регистрации`,
        usePresetDates: true,
      },
    },
  },
  updateDate: {
    apps: {
      [fieldApps.FILTER]: {
        usePresetDates: true,
      },
    },
  },
  assignedDateFrom: {
    apps: {
      [fieldApps.FORM]: {
        defaultDate: null,
      },
    },
  },
  assignedDateTo: {
    apps: {
      [fieldApps.FILTER]: {
        usePresetDates: true,
      },
    },
  },
  text: {
    apps: {
      [fieldApps.FILTER]: {
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  issueLink: {
    apps: {
      [fieldApps.VIEW]: {
        component: nest(WithTitle, IssueLinkFormatter),
      },
    },
  },
  agreement: {
    type: fieldTypes.TEXT,
    name: `Согласование`,
    apps: {
      [fieldApps.FILTER]: {
        title         : `Согласование`,
        component     : MyUserAgreementsCrudFilter,
        paramFieldName: `id`,
        parseValue    : myUserAgreementsFilterParseValue,
        valueToFilter : myUserAgreementsFilterValueToFilter,
      },
    },
  },
  esuzCustom1: {
    type: fieldTypes.TEXT,
    name: `esuz`,
    apps: {
      [fieldApps.VIEW]: {
        component: nest(WithTitle, Text),
        title    : `esuz_view`,
      },
      [fieldApps.FORM]: {
        title    : `esuz_form`,
        component: nest(InputHelper, Input),
      },
      [fieldApps.COLUMN]: {
        name     : `esuz_col`,
        formatter: ({ value }) => (
          <i>
            {value || `нет`}
          </i>
        ),
        width    : 200,
      },
      [fieldApps.FILTER]: {
        title        : `esuz_filter`,
        component    : DebouncedUIKitInput,
        parseValue   : (params) => {
          return get(params, FILTER_TYPE_LIKE)
        },
        valueToFilter: (searchValue) => {
          const searchText = R.isNil(searchValue) ? `` : R.trim(searchValue)
          return {
            [FILTER_TYPE_LIKE]: `"*${searchText}*"`,
          }
        },
      },
    }
  },
  author: {
    name: `Автор`,
    apps: {
      [fieldApps.FORM]: {
        currentUserIsDefault: false,
        component           : nest(InputHelper, UserSelect),
      },
      [fieldApps.COLUMN]: {
        formatter: mapissuesFieldsConf.userId.apps[fieldApps.COLUMN].formatter,
        width    : 200,
      },
      [fieldApps.VIEW]: {
        component: mapissuesFieldsConf.userId.apps[fieldApps.VIEW].component,
      },
    }
  },
  statusId: {
    type: fieldTypes.SELECT,
    name: `Статус`,
    apps: {
      [fieldApps.FORM]: {
        place    : BODY,
        component: nest(InputHelper, StatusEdit),
        title    : `Статус`,
        //required : true,
      },
    },
  },
  point: {
    type: fieldTypes.SELECT,
    name: `Адрес`,
    apps: {
      [fieldApps.FORM]: {
        required : false,
      },
    }
  },
  summary: {
    type: fieldTypes.TEXT,
    name: `Номер ${SYSTEM_ENTITY_NAMES.GENITIVE}`,
    apps: {
      [fieldApps.COLUMN]: {
        name     : `Номер ${SYSTEM_ENTITY_NAMES.GENITIVE}`,
        width    : 110,
      },
    },
  },
  equipmentCodes: {
    type: fieldTypes.SELECT,
    name: `Оборудование`,
    apps: {
      [fieldApps.FORM]: {
        place    : BODY,
        component: nest(InputHelper, Equipment),
        title    : `Оборудование`,
      },
      [fieldApps.COLUMN]: {
        width    : 110,
      },
    },
  },
  planningStartTimestamp: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 135,
        name     : `Дата начала работ`,
      },
    },
  },
  planningEndTimestamp: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 160,
        name     : `Дата окончания работ`,
      },
    },
  },
  externalAgreement: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 165,
      },
    },
  },
  emergencyReadiness: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 50,
        name     : `АГ`,
      },
    },
  },
  categoryCode: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 100,
      },
    },
  },
  reporter: {
    apps: {
      [fieldApps.COLUMN]: {
        width    : 120,
      },
    },
  },
}

export const fieldsConf = merge(
  {},
  mapissuesFieldsConf,
  energyFieldsConfig,
)

export const issuesColumnsList = [
  `id`,
  `summary`,
  `statusId`,
  `typeId`,
  `createDate`,
  `files`,
  `point`,
]

export const issuesViewList = [
  `assignedUserId`,
  `statusId`,
  `id`,
  `createDate`,
  `assignedDateFrom`,
  `assignedDateTo`,
  `userId`,
  `point`,
  `summary`,
  `text`,
  `files`,
  `archived`,
]

export const defaultFilterList = [
  `id`,
  `typeId`,  
  `statusId`,  
  `createDate`,  
  `assignedDateTo`,
  `assignedUserId`,
  `agreement`,
  `archived`,
]

export const defaultFormListEdit = [
  `point`,
  `addressFields`,
  `typeId`,
  `summary`,
  `assignedUserId`,
  `assignedDateFrom`,
  `assignedDateTo`,
  `text`,
  `files`,
  `statusId`, // добавление
]

export const defaultFormList = [
  `point`,
  `addressFields`,
  `typeId`,
  `summary`,
  `assignedUserId`,
  `assignedDateFrom`,
  `assignedDateTo`,
  `text`,
  `files`,
  `statusId`, // добавление
]

export const getFormConfig = (fieldsList, fieldsConfig, metadata) => (
  defaultModuleConfig.getFormConfig(fieldsList, fieldsConf, metadata)
)

export const getFilterConfig = (fieldsList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.filter.getFilterConfig(fieldsList, fieldsConf, metadata)
)

export const getViewConfig = (viewList, fieldsConfig, metadata) => (
  defaultModuleConfig.getViewConfig(issuesViewList, fieldsConf, metadata)
)

export const getGridConfig = (columnsList, fieldsConfig, metadata) => (
  defaultModuleConfig.getGridConfig(columnsList || issuesColumnsList, fieldsConf, metadata)
)

export const getAllColumns = (columnsList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.getAllColumns(issuesColumnsList, fieldsConf, metadata)
)

export const getAllFilters = (filtersList, fieldsConfig, metadata) => (
  defaultModuleConfig.routing.list.filter.getAllFilters(filtersList, fieldsConf, metadata)
)
